export const MAP_PIN_SVG = {
  fillColor: '#194258',
  fillOpacity: 1,
  /* eslint-disable-next-line max-len */
  path: 'M13.5478 32.4705C16.7939 27.873 23.9752 17.1216 23.9752 11.9876C23.9752 8.80828 22.7122 5.75919 20.4641 3.51108C18.216 1.26297 15.1669 0 11.9876 0C8.80828 0 5.75919 1.26297 3.51108 3.51108C1.26297 5.75919 0 8.80828 0 11.9876C0 17.1216 7.18132 27.873 10.4274 32.4705C11.1972 33.5608 12.778 33.5608 13.5478 32.4705ZM15.9836 11.9876C15.9836 14.1944 14.1945 15.9834 11.9877 15.9834C9.78084 15.9834 7.99183 14.1944 7.99183 11.9876C7.99183 9.78072 9.78084 7.99171 11.9877 7.99171C14.1945 7.99171 15.9836 9.78072 15.9836 11.9876Z',
  rotation: 0,
  scale: 1,
  strokeWeight: 0,
};
